/**
 * @file: 层板落位步长标尺
 * @author: xiaolong.huang@dmall.com
 */

import FrontCubeData from '../../../frontCubeData/index';
import Utils from '../../../utils/util';

const scaleFactor: number = 2;
const gridWidth: LogicsicsMeasurement = 12;

function renderGrid(cube: CubeNode): void {
    // 单测环境不执行
    if (typeof isMochaSys !== 'undefined') {
        return;
    }
    drawGrid(cube.jView.find('.left_grid').get(0), cube);
    drawGrid(cube.jView.find('.right_grid').get(0), cube);
}

function drawGrid(canvas: HTMLCanvasElement, cube: CubeNode): void {
    let height: LogicsicsMeasurement = FrontCubeData.getLogicValue(cube.id, 'height');
    let holeSpacing: LogicsicsMeasurement = FrontCubeData.getLogicValue(cube.id, 'holeSpacing');
    let firstHolePosY: LogicsicsMeasurement = FrontCubeData.getLogicValue(cube.id, 'firstHolePosY');
    let ctx: CanvasRenderingContext2D = canvas.getContext('2d');

    if (holeSpacing <= 0) {
        $(canvas).addClass('grid--hide');
        return;
    }
    $(canvas).removeClass('grid--hide');
    setSize(canvas, height);
    ctx.scale(scaleFactor, scaleFactor);
    drawBG(ctx, height);
    drawStepLine(ctx, height, holeSpacing, firstHolePosY);
}

function setSize(canvas: HTMLCanvasElement, height: LogicsicsMeasurement): void {
    canvas.height = height * scaleFactor;
    canvas.width = gridWidth * scaleFactor;
    canvas.style.height = `${height}px`;
    canvas.style.width = `${gridWidth}px`;
}

function drawBG(ctx: CanvasRenderingContext2D, height: LogicsicsMeasurement): void {
    ctx.rect(0, 0, gridWidth, height);
    ctx.fillStyle = "#808040";
    ctx.fill();
    ctx.restore();
}

function drawStepLine(ctx: CanvasRenderingContext2D, height: LogicsicsMeasurement, space: LogicsicsMeasurement, start: LogicsicsMeasurement): void {
    let startLine: LogicsicsMeasurement = Utils.math(height, start, '-');
    let y: LogicsicsMeasurement = startLine;

    ctx.lineWidth = 2;
    ctx.strokeStyle = '#4d4d4d';
    ctx.beginPath();

    while(y >= 0) {
        ctx.moveTo(0, y);
        ctx.lineTo(gridWidth, y);
        y = Utils.math(y, space, '-');
    }

    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}

export {
    renderGrid
};
